import React from 'react'
import { Badge } from 'react-bootstrap';

function GenericBadge(props) {
    let variant = "danger";
    let textcolor = "white";
    switch (props.status.toLowerCase()) {
        case "expired":
        case "licensing":
        case "declined":
        case "issue":
            variant = "danger";
            break;
        case "pending":
        case "enforcement":
            variant = "warning";
            textcolor = "dark";
            break;
        case "active":
        case "complete":
        case "verified":
        case "applications":
        case "approved":
            variant = "success";
            break;
        case 'incomplete':
        case 'board/staff':
        case 'reviewed':
        case 'license':
        case 'hold':
        case 'not yet sent':
            variant = "secondary";
    }
    return (
        <Badge bg={variant} text={textcolor}><b>{props.status}</b></Badge>
    )
}

export default GenericBadge